import { resources } from "@constants/hardcoded-strings";
import { TabTitleWithErrorCount } from "@containers/common/tab-title-with-error-count/tab-title-with-error-count";
import { MetadataServiceTemplateValidationErrors, ServiceTemplateValidationErrors } from "@idw-types/common/validation/service-template/service-template-validation-errors";
import { RpServiceTemplate } from "@idw-types/data/reference-data/generic";
import { ServiceTemplateDetails } from "@idw-types/data/service-template-details/service-template-details";
import { getErrorAlert } from "@utils/tab-util";

export const getServiceTemplateValidationErrors = (serviceTemplateDetails: ServiceTemplateDetails, serviceTemplatesMap: Record<string, RpServiceTemplate>, shouldIgnoreRequiredValidation = false): ServiceTemplateValidationErrors => {
    const metadataErrors = getMetadataValidationErrors(serviceTemplateDetails, serviceTemplatesMap, shouldIgnoreRequiredValidation);
    const count = metadataErrors.count;
    return {
        metadata: metadataErrors,
        count
    }
}

const getMetadataValidationErrors = (serviceTemplateDetails: ServiceTemplateDetails, serviceTemplatesMap: Record<string, RpServiceTemplate>, shouldIgnoreRequiredValidation: boolean): MetadataServiceTemplateValidationErrors => {
    let nameError: React.ReactNode = null;
    let descriptionError: React.ReactNode = null;
    let ssoTemplateError: React.ReactNode = null;

    let count = 0;

    const { name, description, ssoTemplate, id } = serviceTemplateDetails;

    if (name !== '') {
        if (name.length > 255) {
            nameError = getErrorAlert('The name must have a maximum of 255 characters');
            count++;
        }

        if (serviceTemplatesMap[name] && serviceTemplatesMap[name].id !== id) {
            nameError = getErrorAlert('The name already exist');
            count++;
        }

    } else {
        if(!shouldIgnoreRequiredValidation) {
            nameError = getErrorAlert(resources.common.requiredField);
            count++;
        }
    }

    if (!shouldIgnoreRequiredValidation && description === '') {
        descriptionError = getErrorAlert(resources.common.requiredField);
        count++;
    }

    if (ssoTemplate === '') {
        if(!shouldIgnoreRequiredValidation) {
            ssoTemplateError = getErrorAlert(resources.common.requiredField);
            count++;
        } 
    } else {
        try {
            JSON.parse(ssoTemplate);
        } catch (error) {
            ssoTemplateError = getErrorAlert(
                <>
                    <div>{resources.modals.updateTemplateJSON.errors.jsonValidationError}</div>
                    <div>Error: {`${error}`}</div>
                </>
            );
            count++;
        }
    }


    return {
        tabTitle: <TabTitleWithErrorCount tabName={resources.pages.serviceTemplateDetails.tabs.metadata.tabName} errorCount={count} />,
        nameError,
        count,
        descriptionError,
        ssoTemplateError
    }
}